import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

/**
 * Empty state shown when a site has no warranty data onboarded yet.
 * Replaces the full warranty page content to avoid a misleading "no issues" view.
 */
export function NoWarrantyDataState() {
  return (
    <div
      className="mx-auto mt-12 max-w-lg rounded-lg border border-amber-200 bg-amber-50 p-8 text-center"
      data-testid="no-warranty-data-state"
    >
      <ExclamationTriangleIcon className="mx-auto mb-4 size-12 text-amber-500" />

      <h2 className="mb-2 text-lg font-semibold text-amber-900">
        No warranty data available for this site
      </h2>

      <p className="text-sm text-amber-800">
        This site has not been onboarded for warranty monitoring yet.
      </p>
    </div>
  );
}
